import React from "react";
import { Box, Typography, Grid, Paper, Container } from "@mui/material";

const coreValues = [
  {
    image: "/img/core/core-1.gif",
    title: "Cost Savings",
    description:
      "We are dedicated to assisting our clients in drastically cutting operating expenses so they can more wisely deploy their resources.",
  },
  {
    image: "/img/core/core-2.gif",
    title: "Quality Assurance",
    description:
      "Our ultimate goal is to empower our clients to maximize profits through efficient and effective services that drive growth.",
  },
  {
    image: "/img/core/core-3.gif",
    title: "Customization",
    description:
      "Since every company is different, we provide fully customized solutions that are tailored to each client’s particular needs and goals.",
  },
  {
    image: "/img/core/core-4.gif",
    title: "Profit Maximization",
    description:
      "Our ultimate objective is to enable our clients to optimize profits by providing them with growth-promoting, efficient, and effective services.",
  },
];

const Corevalues = () => {
  return (
    <Box sx={{ padding: 4, background: "transparent", color: "white" }}>
      <Container>
        <Typography
          variant="h4"
          fontWeight={700}
          align="center"
          color="white"
          gutterBottom
        >
          Our Core Values
        </Typography>
        <Grid container spacing={2} justifyContent="center">
          {coreValues.map((value, index) => (
            <Grid item xs={12} sm={6} md={11} key={index}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={2}>
                  <Paper
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: 2,
                      borderRadius: 2,
                      background: "#B6BFE033",
                      backdropFilter: "blur(10px)",
                      color: "white",
                      height: "100%",
                      // borderColor: "#B6BFE080",
                      border: "3px solid #B6BFE080",
                    }}
                  >
                    <Box sx={{ textAlign: "center" }}>
                      <img
                        src={value.image}
                        alt={value.title}
                        style={{ width: "100%", height: "auto" }}
                      />
                    </Box>
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={10}>
                  <Paper
                    sx={{
                      padding: 4,
                      borderRadius: 2,
                      background: "#B6BFE033",
                      backdropFilter: "blur(10px)",
                      color: "white",
                      height: "100%",
                      border: "3px solid #B6BFE080",
                    }}
                  >
                    <Typography
                      variant="h6"
                      fontWeight={700}
                      sx={{ color: "#fff" }}
                    >
                      {value.title}
                    </Typography>
                    <Typography variant="body1" sx={{ color: "#fff" }}>
                      {value.description}
                    </Typography>
                  </Paper>
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Corevalues;
